import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiErrorParser, CoreException, Failure, Response, Success } from '@sdk/sdk';
import { firstValueFrom } from 'rxjs';
import { McpClientRequest, McpRequestsRepository } from '../auth';
import { ApiMcpClientRequestMap } from './api-mcp-client-request.map';
import { ApiMcpClientRequestMapper } from './api-mcp-client-request.mapper';

const REQUEST_PATH = 'oauth/request';

@Injectable({
  providedIn: 'root'
})
export class ApiMcpRequestsRepository implements McpRequestsRepository {
  private _errorParser = new ApiErrorParser();
  private _mapper = new ApiMcpClientRequestMapper();

  constructor(private _http: HttpClient) {}

  async get(serverOrigin: string, state: string): Promise<Response<McpClientRequest, CoreException>> {
    const url = new URL(REQUEST_PATH, serverOrigin);
    url.searchParams.set('state', state);
    try {
      const result = await firstValueFrom(this._http.get<ApiMcpClientRequestMap>(url.toString()));
      return new Success(this._mapper.fromMap(result));
    } catch (error) {
      return new Failure(this._errorParser.parse(error));
    }
  }
}
